import { Component, effect, inject, input, model, output } from '@angular/core';
import { I18nModule, RoutingService } from "@spartacus/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { PaymentsMods, PreferencesTabs } from "../../config/app.config";
import { PaymentInfo } from "../../models/payment-info.model";
import { CommonUtils } from "../../utils/common.utils";

@Component({
  selector: 'app-payments-dropdown',
  standalone: true,
  imports: [
    I18nModule,
    NgSelectModule,
    NgbDropdown,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    FormsModule
  ],
  templateUrl: './payments-dropdown.component.html',
})
export class PaymentsDropdownComponent {
  private readonly router = inject(RoutingService);

  selectedPaymentMethod = model<PaymentInfo>();
  allPaymentsMethods = input.required<PaymentInfo[]>();
  eligiblePaymentMethods = input([]);
  payNowDisabled = input(false);
  mix = input('');
  splitOrder = input(false);

  openAddEcIframe = output();
  openAddCardIframe = output();

  constructor() {
    effect(() => {
      if (this.payNowDisabled() || this.splitOrder()) {
        this.selectBillMeLater();
      }
    }, {allowSignalWrites: true});
  }

  getPaymentMethodName(methodNumber: string): string {
    return methodNumber ? `****${ methodNumber.split('-').pop() }` : '';
  }

  walletClick($event: MouseEvent): void {
    $event.preventDefault();
    $('.paymentMethodsDropdown__cardsDropdown').toggleClass('d-none');
  }

  goToProfilePage(): void {
    void this.router.go(['/my-account/profile'], {
      queryParams: { activeTab: PreferencesTabs.PAYMENT },
    });
  }

  onOpenAddECIframe() {
    this.openAddEcIframe.emit();
  }

  onOpenAddCardIframe() {
    this.openAddCardIframe.emit();
  }

  protected readonly PaymentsMods = PaymentsMods;

  selectBillMeLater(): void {
    this.selectedPaymentMethod.set(CommonUtils.setBillMeLaterMethod());
  }

  noDefaultPaymentMethod(): boolean {
    return !this.allPaymentsMethods()?.some((item) => item.creditCardDefault);
  }

  shouldBillMeLaterBeDefault(): boolean {
    return this.noDefaultPaymentMethod() && this.eligiblePaymentMethods()?.includes(PaymentsMods.BILL_ME_LATER);
  }

  noDefaultMethodAndEligibleToBillMeLater(): boolean {
    return this.eligiblePaymentMethods().length === 1 && (this.shouldBillMeLaterBeDefault() || !this.shouldDisplayWalletButton());
  }

  noMethodsAddedAndEligibleToBillMeLater(): boolean {
    return this.eligiblePaymentMethods()?.includes(PaymentsMods.BILL_ME_LATER) && !this.allPaymentsMethods().length;
  }

  shouldDisplayWalletButton(): boolean {
    return !this.eligiblePaymentMethods()?.every(method => method === PaymentsMods.BILL_ME_LATER);
  }
}
